import { BaseService } from "./../base";
export class IdentificationTypeService extends BaseService {
  static get entity() {
    return "identificationtype";
  }
  static get name() {
    return "identification";
  }
  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }
}
